import { AGRONOMY_NO_UNITS_MAX } from 'appConstants';
import type { IValidationField } from 'hooks/useValidations/types';
import { getFixedT, t } from 'i18next';
import * as yup from 'yup';

export default function agreementNoUnits({ label = '' }: IValidationField) {
  const tCropForm = getFixedT(null, 'CreateAgronomyAgreement', 'CropForm');
  const rangeMessage = tCropForm('errors.numberOfUnitsRange', {
    label,
    min: 1,
    max: AGRONOMY_NO_UNITS_MAX,
  });

  return yup
    .number()
    .label(label)
    .typeError(t('errors.required'))
    .required()
    .positive(rangeMessage)
    .integer(`${t('errors.integerNumber')}`)
    .max(AGRONOMY_NO_UNITS_MAX, rangeMessage);
}
